import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'
import {updateArrayItem} from '../utils/helpers'

const reducers = {}
const initialState = {
	customers: []
}

/**
 * Handles loading pending service requests in state
 */
reducers[types.LOAD_SERVICE_REQUESTS] = (state = initialState, action) => {
	return Object.assign({}, state, {
		customers: action.payload.serviceRequests
	})
}

reducers[types.START_SESSION] = (state = initialState, action) => {
	return Object.assign({}, state, {
		customers: updateArrayItem(state.customers, customer => customer._id === action.payload.requestId, {
			isStartingSession: true,
			errorStartingSession: false,
			isSessionStarted: false
		})
	})
}

reducers[types.END_SESSION_LOSSASS] = {
    throw (state, action) {
        if(!action.error){
            return Object.assign({}, state, {
                customers: []
            })
        }
    }
}

reducers[types.CANCEL_SERVICE_REQUEST] = (state = initialState, action) => {
	return Object.assign({}, state, {
		customers: updateArrayItem(state.customers, customer => customer._id === action.payload.requestId, {
			isCancelingRequest: true,
			isRequestCanceled: false
		})

	})
}

reducers[types.CANCEL_SERVICE_REQUEST_FINISH] = (state = initialState, action) => {
	return Object.assign({}, state, {
        customers:state.customers.filter(customer => customer._id !== action.payload.requestId)
		// customers: updateArrayItem(state.customers, customer => customer._id === action.payload.requestId, {
		// 	isCancelingRequest: true,
		// 	isRequestCanceled: true
		// })
	})
}
reducers.updateMsg = (state = initialState, action) => {
		return Object.assign({}, state, action.payload);
}


// This creates a reducer function made up of many reducers.
// The key is the action type for each reducer. The `next`
// function is for successful actions and `throw` is for
// error actions. When a value is a function instead of
// an object, the same function is used for success and failure
export default handleActions(reducers, initialState)
